import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
export function ApplicationForm() {
  const [tab, setTab] = useState<'model' | 'photographer'>('model');
  const [accommodation, setAccommodation] = useState('');
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Form submitted for:', tab, 'accommodation:', accommodation);
  };
  return <section id="bewerbung" className="py-24 md:py-32 px-6 bg-[#f5f5f7] relative overflow-hidden" data-id="element-37">
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-brand-accent/5 rounded-full blur-[120px] pointer-events-none" data-id="element-38" />
      <div className="absolute bottom-0 left-0 w-[500px] h-[500px] bg-brand-accent/5 rounded-full blur-[120px] pointer-events-none" data-id="element-39" />

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-40">
        <div className="text-center mb-12" data-id="element-41">
          <span className="block text-xs font-body tracking-[0.3em] text-brand-accent uppercase mb-4" data-id="element-42">
            Bewerbung
          </span>
          <h2 className="text-4xl md:text-5xl font-heading text-[#1a1a2e] mb-6" data-id="element-43">
            Werde Teil der nächsten Reise.
          </h2>
          <p className="text-[#4a4a5a] font-light leading-relaxed" data-id="element-44">
            Fülle das Formular aus und wir melden uns bei dir. Bitte beachte,
            dass die Plätze begrenzt sind und wir nach kreativem Fit auswählen.
          </p>
        </div>

        <div className="bg-white border border-[#e2e2e6] rounded-2xl p-6 md:p-10 shadow-lg" data-id="element-45">
          {/* Tab Switcher */}
          <div className="flex space-x-2 md:space-x-8 border-b border-[#e2e2e6] mb-8" data-id="element-46">
            <button onClick={() => setTab('model')} className={`pb-4 px-2 text-sm md:text-base font-medium transition-colors relative ${tab === 'model' ? 'text-brand-accent' : 'text-[#8a8a9a] hover:text-[#1a1a2e]'}`} data-id="element-47">
              Als Model bewerben
              {tab === 'model' && <motion.div layoutId="activeTab" className="absolute bottom-0 left-0 right-0 h-0.5 bg-brand-accent" data-id="element-48" />}
            </button>
            <button onClick={() => setTab('photographer')} className={`pb-4 px-2 text-sm md:text-base font-medium transition-colors relative ${tab === 'photographer' ? 'text-brand-accent' : 'text-[#8a8a9a] hover:text-[#1a1a2e]'}`} data-id="element-49">
              Als Fotograf anfragen
              {tab === 'photographer' && <motion.div layoutId="activeTab" className="absolute bottom-0 left-0 right-0 h-0.5 bg-brand-accent" data-id="element-50" />}
            </button>
          </div>

          {/* Form */}
          <form onSubmit={handleSubmit} className="space-y-6" data-id="element-51">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-52">
              <div className="space-y-2" data-id="element-53">
                <label className="text-xs text-[#8a8a9a] uppercase tracking-wider" data-id="element-54">
                  Name
                </label>
                <input type="text" required className="w-full bg-[#f5f5f7] border border-[#e2e2e6] rounded-lg px-4 py-3 text-[#1a1a2e] placeholder:text-[#8a8a9a] focus:outline-none focus:border-brand-accent transition-colors" placeholder="Dein Name" data-id="element-55" />
              </div>
              <div className="space-y-2" data-id="element-56">
                <label className="text-xs text-[#8a8a9a] uppercase tracking-wider" data-id="element-57">
                  E-Mail
                </label>
                <input type="email" required className="w-full bg-[#f5f5f7] border border-[#e2e2e6] rounded-lg px-4 py-3 text-[#1a1a2e] placeholder:text-[#8a8a9a] focus:outline-none focus:border-brand-accent transition-colors" placeholder="deine@email.com" data-id="element-58" />
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-59">
              <div className="space-y-2" data-id="element-60">
                <label className="text-xs text-[#8a8a9a] uppercase tracking-wider" data-id="element-61">
                  Instagram Handle
                </label>
                <input type="text" required className="w-full bg-[#f5f5f7] border border-[#e2e2e6] rounded-lg px-4 py-3 text-[#1a1a2e] placeholder:text-[#8a8a9a] focus:outline-none focus:border-brand-accent transition-colors" placeholder="@deinprofil" data-id="element-62" />
              </div>
              <div className="space-y-2" data-id="element-63">
                <label className="text-xs text-[#8a8a9a] uppercase tracking-wider" data-id="element-64">
                  Portfolio Link (Optional)
                </label>
                <input type="url" className="w-full bg-[#f5f5f7] border border-[#e2e2e6] rounded-lg px-4 py-3 text-[#1a1a2e] placeholder:text-[#8a8a9a] focus:outline-none focus:border-brand-accent transition-colors" placeholder="https://..." data-id="element-65" />
              </div>
            </div>

            <AnimatePresence mode="wait" data-id="element-66">
              {tab === 'photographer' && <motion.div initial={{
              opacity: 0,
              height: 0
            }} animate={{
              opacity: 1,
              height: 'auto'
            }} exit={{
              opacity: 0,
              height: 0
            }} className="grid grid-cols-1 md:grid-cols-2 gap-6 overflow-hidden" data-id="element-67">
                  <div className="space-y-2 pt-2" data-id="element-68">
                    <label className="text-xs text-[#8a8a9a] uppercase tracking-wider" data-id="element-69">
                      Name des Models
                    </label>
                    <input type="text" required className="w-full bg-[#f5f5f7] border border-[#e2e2e6] rounded-lg px-4 py-3 text-[#1a1a2e] placeholder:text-[#8a8a9a] focus:outline-none focus:border-brand-accent transition-colors" placeholder="Name der Begleitung" data-id="element-70" />
                  </div>
                  <div className="space-y-2 pt-2" data-id="element-71">
                    <label className="text-xs text-[#8a8a9a] uppercase tracking-wider" data-id="element-72">
                      Instagram des Models
                    </label>
                    <input type="text" required className="w-full bg-[#f5f5f7] border border-[#e2e2e6] rounded-lg px-4 py-3 text-[#1a1a2e] placeholder:text-[#8a8a9a] focus:outline-none focus:border-brand-accent transition-colors" placeholder="@modelprofil" data-id="element-73" />
                  </div>
                </motion.div>}
            </AnimatePresence>

            {/* Accommodation Preference */}
            <div className="space-y-2" data-id="element-74">
              <label className="text-xs text-[#8a8a9a] uppercase tracking-wider" data-id="element-75">
                Gewünschte Unterbringung
              </label>
              <select value={accommodation} onChange={e => setAccommodation(e.target.value)} required className="w-full bg-[#f5f5f7] border border-[#e2e2e6] rounded-lg px-4 py-3 text-[#1a1a2e] focus:outline-none focus:border-brand-accent transition-colors appearance-none" style={{
              backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%238a8a9a' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='m6 9 6 6 6-6'/%3E%3C/svg%3E")`,
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'right 1rem center'
            }} data-id="element-76">
                <option value="" disabled data-id="element-77">
                  Bitte wählen…
                </option>
                <option value="shared" data-id="element-78">
                  Mehrbettzimmer (geteiltes Zimmer) — günstigster Preis
                </option>
                <option value="double-shared" data-id="element-79">
                  Doppelzimmer geteilt (2 Personen) — mittlerer Preis
                </option>
                <option value="single" data-id="element-80">Einzelzimmer — Aufpreis</option>
                <option value="flexible" data-id="element-81">Flexibel / Keine Präferenz</option>
              </select>
              <p className="text-xs text-[#8a8a9a] font-light mt-1" data-id="element-82">
                💡 Wir empfehlen geteilte Zimmer, um den Preis niedrig zu
                halten. Einzelzimmer sind begrenzt verfügbar und mit Aufpreis
                verbunden.
              </p>
            </div>

            <div className="space-y-2" data-id="element-83">
              <label className="text-xs text-[#8a8a9a] uppercase tracking-wider" data-id="element-84">
                Nachricht
              </label>
              <textarea rows={4} required className="w-full bg-[#f5f5f7] border border-[#e2e2e6] rounded-lg px-4 py-3 text-[#1a1a2e] placeholder:text-[#8a8a9a] focus:outline-none focus:border-brand-accent transition-colors resize-none" placeholder="Erzähl uns kurz von dir und warum du dabei sein möchtest..." data-id="element-85" />
            </div>

            <button type="submit" className="w-full py-4 bg-brand-accent/85 text-white font-medium rounded-lg hover:bg-brand-accent transition-colors mt-4" data-id="element-86">
              {tab === 'model' ? 'Bewerbung absenden' : 'Anfrage senden'}
            </button>
          </form>
        </div>
      </div>
    </section>;
}